import React, { createContext } from 'react';

const access_context = createContext();

export default access_context;